import { createContext, type ReactNode, useContext, useEffect, useMemo } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { usePresentationModeContext } from 'widgets/PresentationMode'
import { CompliancePageStore } from 'pages/settings/pages/compliance/store/compliancePageStore'
import { type ComplianceLayerStore } from 'pages/settings/pages/compliance/store/complianceLayerStore'

const CompliancePageContext = createContext<CompliancePageStore | null>(null)

export const useCompliancePageContext = () => {
  const context = useContext(CompliancePageContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with CompliancePageProvider')

  return context
}

export const CompliancePageProvider = ({
  complianceLayerStore,
  children,
}: {
  complianceLayerStore: ComplianceLayerStore
  children: ReactNode
}) => {
  const presentationStore = usePresentationModeContext()
  const entities = useEntitiesContext()
  const store = useMemo(
    () => new CompliancePageStore(complianceLayerStore, presentationStore, entities),
    []
  )

  useEffect(() => store.dispose, [])

  return <CompliancePageContext.Provider value={store}>{children}</CompliancePageContext.Provider>
}
